<template>
  <div class="page-nav">
    <router-link class="page-nav-row" :class="{ active: index === active }" v-for="(item, index) in list" :key="item.name" :to="item.path">{{ item.name }}</router-link>
  </div>
</template>
<script>
export default {
  name: 'PageNav',
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      list: [
        { name: this.$i18n.$t('关于平台'), path: '/about' },
        // { name: '开发团队', path: '/team' },
        { name: this.$i18n.$t('使用说明'), path: '/describe' },
        { name: this.$i18n.$t('问题反馈'), path: '/feedback' }
      ]
    }
  }
}
</script>
